import { RestRequest, RestContext, ResponseFunction } from 'msw'
import {
  addToEntityListData,
  updateEntityListData,
  deleteEntityListData,
} from '../../modules/mockDataCommon'
import { requireAuthenticatedUser } from '../../decorators'
import {
  getTsdSupplierListData,
  getTsdSupplierOpportunityRegistrationEmailAddressListDataByTsdSupplier,
} from '~/api/msw/api/tsdSuppliers/mockData'

// get

async function getTsdSupplierOpportunityRegistrationEmailAddresses_byId(
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) {
  const { id } = req.params
  if (typeof id !== 'string') {
    const responseBody = {
      statusCode: 500,
      message: 'Passed ID is not a string.',
    }
    return res(ctx.status(500), ctx.json(responseBody))
  }
  console.log(
    `'Returning tsdSupplierOpportunityRegistrationEmailAddresses for tsdSupplier "${id}".`
  )
  return res(
    ctx.status(200),
    ctx.json({
      data: await getTsdSupplierOpportunityRegistrationEmailAddressListDataByTsdSupplier(
        id
      ),
    })
  )
}

// post

const postTsdSupplier = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return addToEntityListData(req, res, ctx, getTsdSupplierListData)
}

const patchTsdSupplier = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return updateEntityListData(req, res, ctx, getTsdSupplierListData)
}

const deleteTsdSupplier = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return deleteEntityListData(req, res, ctx, getTsdSupplierListData)
}

export const handlers = [
  {
    method: 'get',
    path: '/api/tsdsuppliers/:id/opportunityregistrationemailaddresses',
    handler: getTsdSupplierOpportunityRegistrationEmailAddresses_byId,
  },
  {
    method: 'post',
    path: '/api/tsdsuppliers',
    handler: postTsdSupplier,
  },
  {
    method: 'patch',
    path: '/api/tsdsuppliers/:id',
    handler: patchTsdSupplier,
  },
  {
    method: 'delete',
    path: '/api/tsdsuppliers/:id',
    handler: deleteTsdSupplier,
  },
].map((h) => ({ ...h, ...{ handler: requireAuthenticatedUser(h.handler) } }))
